<template>
  <div class="padding-10px">
    <el-card class="box-card" shadow="none" style="min-height: 500px;">
      <div slot="header" class="clearfix" style="display: flex; flex-direction: column">
        <el-row>
          <el-col :span="5">
            <el-input size="medium" placeholder="搜索关键字: 部门名称" v-model="deptName" style="width: 97%;"></el-input>
          </el-col>
          <el-col :span="2">
            <el-button size="medium" type="primary" icon="el-icon-search" @click="searchDept()">搜索</el-button>
          </el-col>
          <el-col :span="13">
            <div>&nbsp;</div>
          </el-col>
          <el-col :span="4">
            <el-button size="medium" type="success" @click="openDialog(true, null)"
              v-if="checkButtonPermission('system:manage:dept:add')">新增部门</el-button>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-table :data="tableData" border fixed style="width: 100%">
          <el-table-column prop="deptName" label="部门名称" min-width="100"></el-table-column>
          <el-table-column prop="parentName" label="上级部门" min-width="100"></el-table-column>
          <el-table-column prop="orderNum" label="排序" min-width="100"></el-table-column>
          <el-table-column prop="delFlag" label="状态" min-width="90">
            <template slot-scope="scope">
              <span v-if="scope.row.delFlag === -1">已删除</span>
              <span v-else-if="scope.row.delFlag === 0">正常</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="100" fixed="right">
            <template slot-scope="scope">
              <el-button @click="openDialog(false, scope.row)" type="success" size="mini"
                v-if="checkButtonPermission('system:manage:dept:edit')">编辑
              </el-button>
              <el-button @click="deleteMenu(scope.row.deptId)" type="danger" size="mini"
                v-if="checkButtonPermission('system:manage:dept:delete')">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin: 18px 0px; float: right;">
          <el-pagination background @current-change="currentPageChange" @size-change="pageSizeChange"
            :current-page="currentPage" :page-sizes="[5, 10, 25, 50, 100]" :page-size="pageSize" :page-count="totalPage"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </el-card>
    <el-dialog :title="menudialogTitle + '部门'" :visible.sync="dialogVisible" :modal="false"
      :close-on-click-modal="false" @close="resetForm()">
      <el-form :model="deptForm" label-width="120px" size="medium" style="padding: 0 10%;">
        <el-form-item label="部门名称" prop="deptName">
          <el-input v-model="deptForm.deptName" clearable></el-input>
        </el-form-item>
        <el-form-item label="上级部门" prop="deptId">
          <el-select placeholder="上级部门" v-model="editDialogDeptSelectVal" clearable>
            <el-option v-for="dept in editDialogDepts" :value="dept.deptId" :key="dept.deptId"
              :label="dept.deptName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序" prop="orderNum">
          <el-input v-model="deptForm.orderNum" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('deptForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
export default {
  name: "menuList",
  data() {
    return {
      deptName: '',
      tableData: [],
      deptForm: { orderNum: 0 },
      currentPage: 1,
      pageSize: 10,
      totalPage: 100,
      total: 100000,
      addFlag: true,
      dialogVisible: false,
      dialogOperation: '',
      menudialogTitle: '编辑',
      editDialogRoles: [],
      editDialogRoleSelect: '',
      editDialogRoleSelectVal: '',
      editDialogDepts: [],
      editDialogDeptSelectVal: '',
    }
  },
  created() {
    this.searchDept();
  },
  mounted() {
  },
  methods: {

    searchDept() {
      let reqParam = {
        deptName: this.deptName,
        size: this.pageSize,
        currentPage: this.currentPage,
      };
      this.$http.post('/api/system/dept/list', reqParam, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        let data = resp.data;
        this.tableData = data;
        if (data.code === "0") {
          let pageInfo = data.pageInfo;
          this.tableData = pageInfo.list;
          this.pageSize = pageInfo.pageSize;
          this.total = pageInfo.total;
          this.totalPage = pageInfo.pages;
        } else {
          this.$alert('' + data.message, '温馨提示', {
            confirmButtonText: '确定'
          });
        }
      }).catch(e => {

      })
    },
    editDept(row) {
      this.deptForm.parentId = this.editDialogDeptSelectVal;
      this.$http.post('/api/system/dept/update', this.deptForm, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        let data = resp.data;
        if (data.code === "0") {
          this.$message({
            message: '编辑系统用户信息成功',
            type: 'success'
          });
          this.dialogVisible = false;
          this.resetForm();
          this.searchDept();
        } else {
          this.$alert(data.message, '温馨提示', {
            confirmButtonText: '确定'
          });
        }
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      })
    },
    deleteMenu(deptId) {
      this.$confirm('此操作将永久该部门信息, 是否继续?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/api/system/dept/delete?sysDeptId=' + deptId, {}, {
          headers: {
            accessToken: sessionStorage.getItem('accessToken')
          }
        }).then(resp => {
          let data = resp.data;
          if (data.code === "0") {
            this.$message({
              message: '删除部门信息成功',
              type: 'success'
            });
            this.dialogVisible = false;
            this.searchDept();
          } else {
            this.$alert('' + data.message, '温馨提示', {
              confirmButtonText: '确定'
            });
          }
        }).catch(e => {
          this.$alert('' + e, '温馨提示', {
            confirmButtonText: '确定'
          });
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    addDept() {
      let reqParam = {
        deptName: this.deptForm.deptName,
        orderNum: this.deptForm.orderNum,
        parentId: this.editDialogDeptSelectVal
      };
      this.$http.post('/api/system/dept/save', reqParam, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        console.log(resp);
        let data = resp.data;
        if (data.code === "0") {
          this.$message({
            message: '新增部门信息成功',
            type: 'success'
          });
          this.dialogVisible = false;
          this.resetForm();
          this.searchDept();
        } else {
          this.$alert(data.message, '温馨提示', {
            confirmButtonText: '确定'
          });
        }
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      })

    },
    editDialogRolesChange(val) {
      this.editDialogRoleSelectVal = val;
    },
    editDialogGetRole() {
      this.$http.post('/api/system/sysRole').then(resp => {
        let data = resp.data;
        console.log(data)
        this.editDialogRoles = data;
      }).catch(e => {

      })
    },
    editDialogGetDept() {
      this.$http.post('/api/system/dept/all', {}, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        let data = resp.data;
        console.log(data)
        if (data.code === "0") {
          this.editDialogDepts = data.resultList;
        }
      }).catch(e => {

      })
    },
    submitForm(formName) {
      if ('add' == this.dialogOperation) {
        this.addDept();
      } else if ('edit' == this.dialogOperation) {
        console.log('edit');
        this.editDept(formName);
      } else {
        console.log('error submit!!');
        return false;
      }

    },
    openDialog(addFlag, row) {
      this.editDialogGetDept();

      if (addFlag) {
        this.menudialogTitle = '新增';
        this.dialogOperation = 'add';

      } else {
        this.menudialogTitle = '编辑';
        let temp = {};
        Object.assign(temp, row);
        console.log(temp);
        this.deptForm = temp;
        this.editDialogDeptSelectVal = temp.parentId;
        this.dialogOperation = 'edit';
      }
      this.dialogVisible = true;
    },
    currentPageChange(val) {
      this.currentPage = val;
      this.searchDept();
    },
    pageSizeChange(val) {
      this.pageSize = val;
      this.searchDept();
    },
    resetForm() {
      this.deptForm = { orderNum: 0 };
      this.editDialogDeptSelectVal = '';
    },
    checkButtonPermission(perms) {
      let menuPermsList = sessionStorage.getItem("menuPermsList");
      if (menuPermsList.indexOf(perms) != -1) {
        return true
      } else {
        return false;
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/system/deptList.vue